import { resourceTypeEnabledAtom } from "@/modules/api/resourceTypes.tsx";
import { type VirtualMachineLoc, vmQueryAtom } from "@/modules/compute/vmQuery.ts";
import { mergeQueryStatuses, type QMergedResult } from "@/utils/query/mergeQueries.ts";
import { atomFamily } from "jotai-family";
import { atom } from "jotai/vanilla";

export const diskAttachableQueryAtom = atomFamily((location: string) =>
    atom((get): QMergedResult<VirtualMachineLoc[]> => {
        const vms = get(resourceTypeEnabledAtom("virtual_machine")) ? get(vmQueryAtom(location)) : undefined;

        // Would use `mergeQueries` here, but the query can be `undefined` which it does not support
        return mergeQueryStatuses({ vms }, [...(vms?.data?.values() ?? [])]);
    }),
);
